export default __webpack_public_path__ + "68467482973a820e263b27a912df5814.png";